var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12901_5405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2932 6.29303C12.1057 6.48056 12.0004 6.73487 12.0004 7.00003C12.0004 7.26519 12.1057 7.5195 12.2932 7.70703L16.5862 12L12.2932 16.293C12.1111 16.4816 12.0103 16.7342 12.0125 16.9964C12.0148 17.2586 12.12 17.5094 12.3054 17.6948C12.4908 17.8803 12.7416 17.9854 13.0038 17.9877C13.266 17.99 13.5186 17.8892 13.7072 17.707L18.7072 12.707C18.8947 12.5195 19 12.2652 19 12C19 11.7349 18.8947 11.4806 18.7072 11.293L13.7072 6.29303C13.5197 6.10556 13.2654 6.00024 13.0002 6.00024C12.735 6.00024 12.4807 6.10556 12.2932 6.29303ZM6.29321 6.29303C6.10574 6.48056 6.00043 6.73487 6.00043 7.00003C6.00043 7.26519 6.10574 7.5195 6.29321 7.70703L10.5862 12L6.29321 16.293C6.11105 16.4816 6.01026 16.7342 6.01254 16.9964C6.01482 17.2586 6.11999 17.5094 6.3054 17.6948C6.4908 17.8803 6.74162 17.9854 7.00381 17.9877C7.26601 17.99 7.51861 17.8892 7.70721 17.707L12.7072 12.707C12.8947 12.5195 13 12.2652 13 12C13 11.7349 12.8947 11.4806 12.7072 11.293L7.70721 6.29303C7.51969 6.10556 7.26538 6.00024 7.00021 6.00024C6.73505 6.00024 6.48074 6.10556 6.29321 6.29303Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12901_5405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.ef5cc4c8c55f698d3fc9f142dc929496.svg";
export { ForwardRef as ReactComponent };